// Simple sanitizer for outbound JSON payloads
// Note: This is a defensive client-side sanitation; backend remains the source of truth

const DANGEROUS_TAGS_REGEX = /<\/?(script|style|iframe|object|embed|link|meta)[^>]*>/gi;
const EVENT_HANDLER_ATTR_REGEX = /on[a-z]+\s*=\s*"[^"]*"|on[a-z]+\s*=\s*'[^']*'|on[a-z]+\s*=\s*[^\s>]+/gi;
const JS_URL_REGEX = /javascript\s*:/gi;

export function sanitizeString(value) {
  if (typeof value !== 'string') return value;
  let v = value;
  // Remove dangerous tags
  v = v.replace(DANGEROUS_TAGS_REGEX, '');
  // Strip event handlers
  v = v.replace(EVENT_HANDLER_ATTR_REGEX, '');
  // Remove javascript: URLs
  v = v.replace(JS_URL_REGEX, '');
  return v;
}

function isPlainObject(o) {
  return Object.prototype.toString.call(o) === '[object Object]';
}

export function sanitizePayload(input, seen = new WeakSet()) {
  if (input == null) return input;
  if (seen.has(input)) return input; // prevent cycles

  // Primitives
  const t = typeof input;
  if (t === 'string') return sanitizeString(input);
  if (t !== 'object') return input;

  // Do not touch File, Blob, Date, FormData
  if (
    input instanceof Date ||
    (typeof File !== 'undefined' && input instanceof File) ||
    (typeof Blob !== 'undefined' && input instanceof Blob) ||
    (typeof FormData !== 'undefined' && input instanceof FormData)
  ) {
    return input;
  }

  seen.add(input);

  if (Array.isArray(input)) {
    return input.map((item) => sanitizePayload(item, seen));
  }

  if (isPlainObject(input)) {
    const out = {};
    for (const [k, v] of Object.entries(input)) {
      const safeKey = sanitizeString(k);
      out[safeKey] = sanitizePayload(v, seen);
    }
    return out;
  }

  // For other objects, try not to mutate
  return input;
}
